
import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants.js';
import { View } from 'backbone';
import { Model } from 'backbone';
import listService      from 'ListService.js';
import Template from 'behaviors/properties/main/object-states.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
import widgetUtil from 'util/WidgetUtil.js';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';

class MainObjectStatesView extends View {


    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.minRows = 5;

        this.events = {
            "click button[name='addObject']": "addObject",
            "click button[name='removeObject']": "removeObject",
            "change input[name='objectState']":'changeObjectState'
        };

        this.model.set({
            colModel: [
                {
                    name: 'object',
                    index: 'object',
                    editable: false
                },
                {
                    name: 'state',
                    index: 'state',
                    editable: false
                }
            ],
            colNames: ['Object', 'State']
        }, {silent: true});

        if(!this.model.get('gridData')){
            this.model.set('gridData',[], {silent: true});
            this.loadDataFromProperty();
        }

        else{
            _.forEach(this.model.get('gridData'), (field, index) => {
                field.selected=false;
            })
        }
        this.listenTo(this.model, 'change',this.render);

        this.onResize();

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }
        
        return this;
    }

    loadDataFromProperty() {
        const prop = this.model.get('Property');
        const controls = _.find(prop, function(obj) { return obj._id === 'controls' });
        const states = _.find(prop, function(obj) { return obj._id === 'states' });
        let gridData = this.model.get('gridData');

        if (!controls.Item) { controls.Item = []; }
        if (!states.Item) { states.Item = []; }

        if (Array.isArray(controls.Item)) {
            for (var i = 0; i < controls.Item.length; i++) {
                const id = controls.Item[i]._value;
                let obj = listService.getObject(listService.cleanId(id));
                if (!obj) {
                    obj = listService.getPage(listService.cleanId(id))
                }
                if (!obj) {
                    continue; // no valid object, do not add row
                }
                let name = obj ? obj.model.get('name') : '';
                let cid = obj ? obj.model.get('id') : '';
                let stateValue = '';

                try {
                    stateValue = states.Item[i]._value;
                } catch (e){}

                let newRow = {
                    'id':cid,
                    'object': name ,
                    'state': stateValue,
                    'selected':false
                };

                gridData.push(newRow);

            }
        } else {
            const id = controls.Item._value;
            let obj = listService.getObject(listService.cleanId(id));
            if (!obj) {
                obj = listService.getPage(listService.cleanId(id))
            }

            // only add row if valid object
            if (obj) {
                let name = obj ? obj.model.get('name') : '';
                let cid = obj ? obj.model.get('id') : '';
                let stateValue = '';

                try {
                    stateValue = states.Item._value;
                } catch (e) {
                }

                let newRow = {
                    'id': '',
                    'object': name,
                    'state': stateValue,
                    'selected': false
                };

                gridData.push(newRow);

                // enforce array type
                const newItem = {_value: controls.Item._value};
                controls.Item = [newItem];

                const newStateItem = {_value: states.Item._value};
                states.Item = [newStateItem];
            }

        }



        
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid(); util.makePanelFit();})
    }

    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

   addObject(event){
       let stateModel = new Model();
       stateModel.set('multipleSelectionEnabled', true, { silent: true });
       // Opening Modal for selecting a current control on the page.
       var sfModal = new selectFieldModal({model: stateModel, mode: 'objectsANDlists'});
       let _self = this;

       sfModal.render().then((selectedFields)=>{
            $(selectedFields).each(function (idx, selectedField) {
                var gridData = _self.model.get('gridData');
                var newRow = {
                    'id':selectedField.id,
                    'object':selectedField.name ,
                    'state': 'normal',
                    'selected':false
                };
            // Ignoring blank rows and adding the row at the beginning.
               var newGridData=gridData.filter((item)=>{return item.name !==''});
               let alreadySeted = false;
               newGridData.forEach((item,index) => {
                   if (item.id === newRow.id){
                       alreadySeted = true
                   }
               });
               if (!alreadySeted) {
                   newGridData=[newRow,...newGridData];

                   let controls = _.find(_self.model.attributes.Property, function(obj) { return obj._id === 'controls' });
                   let states = _.find(_self.model.attributes.Property, function(obj) { return obj._id === 'states' });

                   controls.Item.splice(0,0, { _value: selectedField.id } );
                   states.Item.splice(0,0, { _value: 'normal' } );

                   _self.model.set('gridData', newGridData,{silent:true});
                   _self.model.set('widgetText', widgetUtil.getWidgetText(_self.model) ,{silent:true}) ;
               }
            });

           _self.model.trigger('change');
       });
   }  

    removeObject(event){
        var gridData = this.model.get('gridData');
        let selectedRows=$(this.gridEl).jqGrid('getGridParam','selarrrow');
        let selectedIds=[];

        // Gathering the ids currently selected.
        _.forEach(selectedRows,(selectedRow) =>{
            selectedIds.push(gridData[selectedRow].id);
        });

        // Deleting only if there are selected items.
        if(selectedRows) {
            _.forEach(selectedIds, (id, index) => {
                let controls = _.find(this.model.attributes.Property, function (obj) {
                    return obj._id === 'controls'
                });
                let states = _.find(this.model.attributes.Property, function (obj) {
                    return obj._id === 'states'
                });

                // Finding the index to delete
                let mainIndex="";
                _.forEach(controls.Item,(item,index) =>{
                    if (listService.cleanId(item['_value']) === id){
                        mainIndex = index;
                        return false;
                    }
                });

                controls.Item.splice(parseInt(mainIndex), 1);
                states.Item.splice(parseInt(mainIndex), 1);
                gridData.splice(parseInt(mainIndex), 1);
                this.model.set('gridData',gridData,{silent:true});
                this.model.set('widgetText', widgetUtil.getWidgetText(this.model),{silent:true});
            });
            this.model.trigger('change');
        }
    }

    //Avoid console error when double click on table
    onDoubleClickRow(){
        return;
    }

    onSelectRow(rowId, status,e){
        // Retrieving the selected row from the model.
        let gridData=this.model.get('gridData');
        if(gridData[rowId]) {

            // Checking the most current selection
            $(`input[value="${ gridData[rowId].state}"]`).prop('checked', true);
            let selectedRows=$(this.gridEl).jqGrid('getGridParam','selarrrow')


            // Cleaning first.
            _.forEach(gridData, (field, index) => {
                field.selected = false;
            });

            // Setting the refreshed selected rows.
            _.forEach(selectedRows, (field, index) => {
                gridData[field].selected = true;
            });

            // Marked as selected so it can interact with the Radio Button Options.
            // Enabling State and Checking the current state of the row.
            this.model.set('gridData', gridData, {silent: true});

            // If there are no rows selected disabling the radios.
            if(selectedRows.length < 1){
                $('input[name="objectState"]').prop('disabled',true);
            }
            else{
                $('input[name="objectState"]').prop('disabled',false);
            }
        }
         return true;
    }
    
    changeObjectState(event){
        util.saveGridScrollPos(this.model);
        // Getting the current item that is selected on the model.
        let currentGridData=this.model.get('gridData');
        let selectedRows=currentGridData.filter((item)=>{
           return item.selected === true;
        });
        let self=this;

        if(selectedRows){
            _.forEach(selectedRows,function(currentSelectedRow){
                // Changing the state on the selected element.
                let indexOfChangedElement=currentGridData.indexOf(currentSelectedRow);
                currentSelectedRow.state=event.target.value;

                // Updating the model
                let newGridData=[...currentGridData.slice(0,indexOfChangedElement),currentSelectedRow,...currentGridData.slice(indexOfChangedElement + 1)];
                self.model.set('gridData',newGridData,{silent:true});

                let controls = _.find(self.model.attributes.Property, function(obj) { return obj._id === 'controls' });
                const cleanedIdSelectedRow = listService.getCleanedId(currentSelectedRow.id);
                let indexOfSelectedControl = controls.Item.findIndex(e => e._value === cleanedIdSelectedRow);

                let states = _.find(self.model.attributes.Property, function(obj) { return obj._id === 'states' });
                states.Item[indexOfSelectedControl]._value = event.target.value;

                // Render it and updating the radio buttons.
                self.render();
                $('input[name="objectState"]').prop('disabled',false);
                $(`input[value="${currentSelectedRow.state}"]`).prop('checked',true);
            })
        }       
    }
    onCellSelect(rowid, index, contents, event) {

    }

    setRow(rowid, e) {
        let self=this;
        let rowData = $(this.gridEl).jqGrid("getRowData", rowid);
        if(rowData.object === ""  && rowData.state === ""){
            return false;
        }

        // Shifting functionality customized from the application structure.
        // Taking basis on this link https://stackoverflow.com/questions/4186533/jqgrid-multiselect?answertab=active#tab-top
        $(this.gridEl).disableSelection();
        if (!e.ctrlKey && !e.shiftKey) {
            $(this.gridEl).jqGrid('resetSelection');
        }
        else if (e.shiftKey) {
            let initialRowSelect = $(this.gridEl).jqGrid('getGridParam', 'selrow');
            $(this.gridEl).jqGrid('resetSelection');

            let CurrentSelectIndex = $(this.gridEl).jqGrid('getInd', rowid);
            let InitialSelectIndex = $(this.gridEl).jqGrid('getInd', initialRowSelect);
            let startID = initialRowSelect;
            let endID = rowid ;
            let dataIds=$(this.gridEl).getDataIDs();

            // From Top To Bottom.
            if (CurrentSelectIndex > InitialSelectIndex) {
                for(let i = parseInt(startID); i < parseInt(endID); i++){
                    $(self.gridEl).setSelection(dataIds[i], false);
                }
            }

            // From Bottom to Top.
            else {
                for(let i = parseInt(startID); i > parseInt(endID); i--){
                    $(self.gridEl).setSelection(dataIds[i], false);
                }
            }
        }
        return true;
    }

    fillNewRow(grid,index,object,state){
        $(grid).addRowData(index, {object:object, state:state});
    }

    gridComplete(){
        // Hiding checkboxes.
        $(this.gridEl).jqGrid('hideCol', 'cb');
    }

    renderGrid(){
        let self = this;
        util.deleteGridRows(this.gridEl);
        let gridObject = util.getGridObject(this,
             {
                multiselect: true,
                autowidth: true, 
                shrinkToFit: true,
                height: 110,
                cellEdit:false,
                colModel: this.model.get('colModel'),
                colNames: this.model.get('colNames'),
                onCellSelect:this.onCellSelect.bind(self),
                onSelectRow:this.onSelectRow.bind(self),
                beforeSelectRow: this.setRow.bind(self),
                gridComplete:this.gridComplete.bind(self), 
                resizeStop: function(width, index) {
                    let grid = $(self.gridEl);
                    let columns = grid.jqGrid('getGridParam', 'colModel');
                    let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                    if ($("#lui_propMainTable").width() < colWidth) {
                        grid.closest('.ui-jqgrid-bdiv')
                            .css('overflow', '')
                            .addClass('format-table-overflow-shown');
                    }
                }
             });

        $(this.gridEl).jqGrid(gridObject);

         // Filling table with current gridData values.
         let gridData = this.model.get('gridData');
            _.forEach(gridData, (field, index) => {
                self.fillNewRow(this.gridEl, index, field['object'],field['state']);
                if(gridData[index].selected){
                    $(self.gridEl).setSelection(index,false);
                }
            })   
            let gridDataClient = $(this.gridEl).jqGrid('getRowData')
            let size = gridDataClient.length;
            if (size <= this.minRows) {
                var newRow = {
                    'id':'',
                    'object': '' ,
                    'state': '',
                    'selected':false
                };
                for (let i=size; i<this.minRows; ++i) {
                    $(this.gridEl).addRowData((gridDataClient.length + 1), newRow);
                }
            }
            let selectedRows=$(this.gridEl).jqGrid('getGridParam','selarrrow');
            if(selectedRows.length < 1){
                $('input[name="objectState"]').prop('disabled',true);
            }     
            else{
                $('input[name="objectState"]').prop('disabled',false);
            }

         this.delegateEvents();
         this.$el.css('cursor', 'default');


         eventBus.trigger(constants.RESIZE_PROPERTIES_STYLE_PANEL);
    }
    
    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.renderGrid();
        util.setGridScrollPos(this.model);
        return this;
    }
    
    remove(){
        $(window).off('resize');
        super.remove();
    }
}

export default MainObjectStatesView;
